import React, { Component } from 'react'
import { size } from 'lodash'
import menuRouteUtil from '../utils/menuRoute.util'
import MenuItem from './MenuItem'
import menuRoutes from '../routes/menuRoutes'

interface MenuItemsProps {
  fold: boolean
  permittedModules: string[]
  onRoute: (to?: string) => void
}

export default class MenuItems extends Component<MenuItemsProps> {
  get className () {
    const base = 'grid'
    const fold = this.props.fold ? 'grid-cols-2' : 'grid-cols-3'
    return `${base} ${fold}`
  }

  get items () {
    return (
      menuRoutes.map(group => {
        const subsidiaries = menuRouteUtil.collectPermittedCombinedSubsidiaries(
          group.name,
          this.props.permittedModules
        )
        if (!size(subsidiaries)) return null
        return (
          <MenuItem
            text={group.text}
            icon={group.icon}
            to={group.to}
            onRoute={this.props.onRoute}
            key={group.to} />
        )
      })
    )
  }

  render () {
    return (
      <div className='border-t border-b border-white border-opacity-30 py-3'>
        <div className={this.className}>
          {this.items}
        </div>
      </div>
    )
  }
}
